import { render, staticRenderFns } from "./Fleets.vue?vue&type=template&id=b2f275c2&scoped=true&"
import script from "./Fleets.vue?vue&type=script&lang=js&"
export * from "./Fleets.vue?vue&type=script&lang=js&"
import style0 from "./Fleets.vue?vue&type=style&index=0&id=b2f275c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f275c2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2f275c2')) {
      api.createRecord('b2f275c2', component.options)
    } else {
      api.reload('b2f275c2', component.options)
    }
    module.hot.accept("./Fleets.vue?vue&type=template&id=b2f275c2&scoped=true&", function () {
      api.rerender('b2f275c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Fleets.vue"
export default component.exports